import styled from "styled-components";
import { calendarMonthRangeInputBounds } from "../../../work-type-shared/calendar-date-range";
import { Content, Label, Subscription } from "../styles";
import type {
  WorkPolicyApplicationDateField,
  WorkPolicyApplicationFormModel
} from "./use-work-policy-application-form-model";

interface WorkPolicyApplicationMetadataFieldsProps {
  templateTitle: string;
  startDate: WorkPolicyApplicationDateField;
  endDate: WorkPolicyApplicationDateField;
  model: WorkPolicyApplicationFormModel;
  readOnly?: boolean;
}

const BoundaryFact = styled.strong`
  color: ${props => props.theme.colors.black};
`;

const BoundaryHelper = styled.small`
  margin-left: 10px;
  color: ${props => props.theme.colors.darkGrey};
`;

export function WorkPolicyApplicationMetadataFields({
  templateTitle,
  startDate,
  endDate,
  model,
  readOnly = false
}: WorkPolicyApplicationMetadataFieldsProps) {
  const dailyDate =
    model.controller.draft?.workType === "flexible" &&
    model.controller.draft.flexibleMode === "DAILY_DATE";
  const rangeBounds = dailyDate
    ? calendarMonthRangeInputBounds(startDate.value, endDate.value)
    : { startMin: undefined, endMax: undefined };
  return (
    <>
      <Content style={{ gridRow: "span 2" }}>
        <Label>관리이름</Label>
        <Subscription>{templateTitle}</Subscription>
      </Content>
      <Content>
        <Label htmlFor="work-policy-startDate">시작일자</Label>
        <Subscription>
          <input
            id="work-policy-startDate"
            type="date"
            value={startDate.value}
            min={rangeBounds.startMin}
            disabled={readOnly}
            aria-invalid={model.controller.validationIssues.some(
              issue => issue.path === "startDate"
            )}
            onChange={event =>
              model.updateDate("startDate", event.currentTarget.value)
            }
          />
        </Subscription>
      </Content>
      <Content>
        <Label htmlFor="work-policy-endDate">종료일자</Label>
        <Subscription>
          <input
            id="work-policy-endDate"
            type="date"
            value={endDate.value}
            min={startDate.value || undefined}
            max={rangeBounds.endMax}
            disabled={readOnly}
            aria-invalid={model.controller.validationIssues.some(
              issue => issue.path === "endDate"
            )}
            onChange={event =>
              model.updateDate("endDate", event.currentTarget.value)
            }
          />
        </Subscription>
      </Content>
      <Content>
        <Label>시작시간</Label>
        <Subscription>
          <BoundaryFact>00:00:00</BoundaryFact>
        </Subscription>
      </Content>
      <Content>
        <Label>종료시간</Label>
        <Subscription>
          <BoundaryFact>23:59:59</BoundaryFact>
          <BoundaryHelper>
            신청 시작일 00:00부터 종료일 23:59:59까지 적용
          </BoundaryHelper>
        </Subscription>
      </Content>
    </>
  );
}
